// @flow

import React from 'react';
import classNames from 'classnames';
import red from '@mui/material/colors/red';
import { log } from '../../utils/jsUtils';
import { useStore } from '../../store';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import withStyles from '../../utils/withStyles';
import styles from './Styles/AddPropertyDialog.Style';
import type { Tenant } from '../../services/SPBackend';

type Props = {
  classes: Object,
  setOpen: Function,
  open: boolean,
  actionConfirm: Function, // edit tenant
  tenant: Tenant
}

const RemoveTenantFromUnitDialog = (props: Props) => {
  const {
    classes,
    setOpen,
    open,
    actionConfirm,
    tenant
  } = props;
  const [store] = useStore();
  const {
    i18n
  } = store;

  // log('[RemoveTenantFromUnitDialog] open: ', open);
  return (
    <div>
    {
      (tenant !== null && typeof tenant !== 'undefined')
      ? <Dialog
          aria-labelledby='form-add-property'
          onClose={() => setOpen(false)}
          open={open}
        >
          <DialogTitle id='form-dialog-title'>
          {'HEADS UP!'}
          </DialogTitle>
          <DialogContent className={classNames(classes.grow, classes.flexContainer)}>
            <DialogContentText>
              {`You are about to move this ${i18n.t('tenant')} out:`}&nbsp;&nbsp;&nbsp;&nbsp;<br />
              <b style={{color: red[600]}}>{`${tenant.FirstName} ${tenant.LastName}`}</b><br /><br />
              {'Are you sure?'}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
              color='primary'
              onClick={() => setOpen(false)}
              type='button'
            >
              {'Cancel'}
              </Button>
            <Button 
              color='primary'
              onClick={() => { 
                actionConfirm(tenant); 
                setOpen(false); 
                }
              }
              variant='contained'
            >
              {'Remove'}
              </Button>
          </DialogActions>
        </Dialog>
      : null
    }
    </div>
  );
};

export default withStyles(styles)(RemoveTenantFromUnitDialog);